"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAutomaticOnboardingSupported = exports.isSocialSecurityNumberAsked = exports.getOrganizationTypeRadioValues = exports.getAllowedOrganizationCountries = exports.isOnboardingAllowedForCountry = void 0;
const enums_1 = require("../../enums");
const country_1 = require("../enums/country");
const isOnboardingAllowedForCountry = (country, environments) => {
    if (!country) {
        return false;
    }
    return (0, exports.getAllowedOrganizationCountries)(environments).includes(country);
};
exports.isOnboardingAllowedForCountry = isOnboardingAllowedForCountry;
const getAllowedOrganizationCountries = (_environments) => {
    const countries = [
        country_1.OrganizationCountry.Canada,
        country_1.OrganizationCountry.UnitedStates,
        country_1.OrganizationCountry.GreatBritain,
        country_1.OrganizationCountry.Australia,
        country_1.OrganizationCountry.Ireland,
        country_1.OrganizationCountry.Germany,
    ];
    return countries.sort((a, b) => country_1.ORGANIZATION_COUNTRY_MAP[a].countryName.localeCompare(country_1.ORGANIZATION_COUNTRY_MAP[b].countryName));
};
exports.getAllowedOrganizationCountries = getAllowedOrganizationCountries;
const getOrganizationTypeRadioValues = (country, displayedValues) => {
    if (country === country_1.OrganizationCountry.Canada) {
        return {
            [enums_1.OrganizationType.Charity]: displayedValues[enums_1.OrganizationType.Charity],
            [enums_1.OrganizationType.Social]: displayedValues[enums_1.OrganizationType.Social],
            [enums_1.OrganizationType.Private]: displayedValues[enums_1.OrganizationType.Private],
        };
    }
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return {
            [enums_1.OrganizationType.Charity]: displayedValues[enums_1.OrganizationType.Charity],
            [enums_1.OrganizationType.Other]: displayedValues[enums_1.OrganizationType.Other],
            [enums_1.OrganizationType.Private]: displayedValues[enums_1.OrganizationType.Private],
        };
    }
    if (country === country_1.OrganizationCountry.Ireland) {
        return {
            [enums_1.OrganizationType.Charity]: displayedValues[enums_1.OrganizationType.Charity],
        };
    }
    if (country === country_1.OrganizationCountry.Germany) {
        return {
            [enums_1.OrganizationType.Charity]: displayedValues[enums_1.OrganizationType.Charity],
            [enums_1.OrganizationType.Other]: displayedValues[enums_1.OrganizationType.Other],
            [enums_1.OrganizationType.Private]: displayedValues[enums_1.OrganizationType.Private],
        };
    }
    if (country === country_1.OrganizationCountry.Australia) {
        return {
            [enums_1.OrganizationType.Charity]: displayedValues[enums_1.OrganizationType.Charity],
            [enums_1.OrganizationType.Other]: displayedValues[enums_1.OrganizationType.Other],
            [enums_1.OrganizationType.Private]: displayedValues[enums_1.OrganizationType.Private],
        };
    }
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return {
            [enums_1.OrganizationType.Charity]: displayedValues[enums_1.OrganizationType.Charity],
            [enums_1.OrganizationType.Other501C]: displayedValues[enums_1.OrganizationType.Other501C],
            [enums_1.OrganizationType.Other]: displayedValues[enums_1.OrganizationType.Other],
            [enums_1.OrganizationType.Private]: displayedValues[enums_1.OrganizationType.Private],
        };
    }
    return {
        [enums_1.OrganizationType.Charity]: displayedValues[enums_1.OrganizationType.Charity],
        [enums_1.OrganizationType.Other]: displayedValues[enums_1.OrganizationType.Other],
        [enums_1.OrganizationType.Private]: displayedValues[enums_1.OrganizationType.Private],
    };
};
exports.getOrganizationTypeRadioValues = getOrganizationTypeRadioValues;
const isSocialSecurityNumberAsked = (country) => {
    return country === country_1.OrganizationCountry.UnitedStates;
};
exports.isSocialSecurityNumberAsked = isSocialSecurityNumberAsked;
const isAutomaticOnboardingSupported = (country) => {
    return country === country_1.OrganizationCountry.Canada || country === country_1.OrganizationCountry.UnitedStates;
};
exports.isAutomaticOnboardingSupported = isAutomaticOnboardingSupported;
